import React from 'react'

interface LocationIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const LocationIcon: React.FC<LocationIconProps> = ({
  color = '#000',
  gradient,
  width = 17,
  height = 23,
  alt = 'Location icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 17 23'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M0 8.13A8.124 8.124 0 018.13 0a8.124 8.124 0 018.13 8.13c0 1.534-.508 3.201-1.227 4.808-.724 1.614-1.682 3.213-2.632 4.62a50.46 50.46 0 01-3.783 4.902l-.017.019-.005.005-.001.001s-.001.001-.465-.418l-.464.419-.002-.002-.005-.005-.017-.02a25.646 25.646 0 01-.308-.352A50.475 50.475 0 013.86 17.56c-.95-1.408-1.91-3.007-2.633-4.621C.507 11.33 0 9.664 0 8.13zm8.13 13.937l-.464.419.464.514.465-.515-.465-.418zm0-.953a49.235 49.235 0 003.234-4.255c.926-1.372 1.843-2.906 2.527-4.433.688-1.534 1.118-3.015 1.118-4.296a6.874 6.874 0 00-6.88-6.88 6.874 6.874 0 00-6.878 6.88c0 1.28.43 2.762 1.118 4.296.684 1.527 1.6 3.06 2.527 4.433a49.222 49.222 0 003.234 4.255zm0-15.039a2.056 2.056 0 000 4.11 2.056 2.056 0 000-4.11zM4.824 8.13a3.307 3.307 0 016.611 0 3.307 3.307 0 01-6.61 0z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default LocationIcon
